import HttpService from "./HttpService";

let relatorioService = {
  gerarRelatorio: (relatorio) => {
    return HttpService.backApi.get(`/relatorios?relatorio=${relatorio}`);
  },
  consultarPorMenu: (idMenu) => {
    return HttpService.backApi.get(`/relatorios/menu/${idMenu}`);
  },
  gerarRelatorioComChave: (id, idChave, camposExtras) => {
    const params = new URLSearchParams(camposExtras).toString();
    return HttpService.backApi.get(`/relatorios/${id}/chave/${idChave}?${params}`, { responseType: 'blob' });
  }
};

export default relatorioService;
